import React, { createContext, useState, useContext } from 'react';
import {v4 as uuid} from "uuid";

// Create context
const InterestFormContext = createContext();

// Provider component
export const InterestFormProvider = ({ children }) => {

    const idempotencyKey = uuid();
    const initialFormData = {
        firstName: '',
        lastName: '',
        emailAddress: '',
        phoneNumber: '',
        dateOfBirth: '',
        gender: '',
        selectedService: '',
        idempotencyKey: idempotencyKey
    };

    const [formData, setFormData] = useState(initialFormData);

    const updateFormData = (newData) => {
        setFormData((prevData) => ({
            ...prevData,
            ...newData,
        }));
    };

    return (
        <InterestFormContext.Provider value={{ formData, updateFormData }}>
            {children}
        </InterestFormContext.Provider>
    );
};

// Custom hook to use the FormContext
export const useFormContext = () => {
    return useContext(InterestFormContext);
};
